import { BaseMutations } from '@/store/base-mutations';
import { Leads } from '../types';
import LeadsState from './state';

export default class LeadsMutations extends BaseMutations<LeadsState> {
  SET_ITEMS(leads: Leads.Item[]) {
    this.state.items = leads;
  }

  SET_NEW_LEAD_VIA_SOCKET(lead: Leads.Lead) {
    this.state.new_lead_via_socket = lead;
  }

  UPD_NEW_LEAD_VIA_SOCKET_MODAL(value: boolean) {
    this.state.new_lead_via_socket_modal = value;
  }

  UPD_LEAD_DETAILS(lead: Leads.Lead) {
    if (lead.id === this.state.current_lead.id) {
      this.state.current_lead = lead;
    }
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof Leads.RequestFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  SET_CURRENT_LEAD(lead: Leads.Lead) {
    this.state.current_lead = lead;
  }

  SET_TRANSITION_STATUSES(statuses: Leads.AvailableTransitionStatuses[]) {
    this.state.available_transition_statuses = statuses;
  }

  SET_CURRENT_LEAD_LOGS(logs: Leads.LeadLog[]) {
    this.state.lead_logs = logs;
  }

  SET_TABLE_FILTERS(filters: Leads.TableFilters) {
    this.state.statuses = filters.statuses;
    this.state.categories = filters.categories;
    this.state.regions = filters.regions;
    this.state.types = filters.types;
  }

  SET_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  UPD_RESERVE_LEAD_MODAL(value: boolean) {
    this.state.reserved_lead_dialog_modal = value;
  }

  SET_IS_READ_ONLY(value: boolean) {
    this.state.is_read_only = value;
  }

  SET_RESERVED_LEAD_MESSAGE(message: string) {
    this.state.reserved_lead_dialog_message = message;
  }
}
